import { Card } from "@mui/material";
import styled from "styled-components";

interface IStyledCard {
    variant?: "default" | "outlined";
    autoHeight?: boolean;
    mb?: number;
}

const StyledCard = styled(Card)<IStyledCard>`
    background-color: ${(props) => props.theme.mainBackground};
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: ${(props) => props.mb || 0}px;
    height: ${(props) => (props.autoHeight ? "auto" : "100%")};

    &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    .MuiCardContent-root {
        color: ${(props) => props.theme.textPrimary};
    }
`;

export default StyledCard;
